import React from 'react'
import { faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useFormikContext } from 'formik'
import { Address, Dropdown, Input } from 'src/components/Forms'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import { DefaultLookupsReturn, UseLookupsReturn } from '../helpers/useLookups'
import Phone from 'src/components/Forms/Phone'

interface FormProps {
  toggle: () => void
  isLoading?: boolean
  hasError?: boolean
  disableSave?: boolean
  lookups?: UseLookupsReturn
}

const Form: React.FC<FormProps> = (props) => {
  const { hasError, toggle, isLoading, disableSave, lookups = DefaultLookupsReturn } = props
  const { handleSubmit, isValid } = useFormikContext()
  const canSave = disableSave === false && isValid && isLoading === false
  return (
    <>
      <Body error={{
        error: 'There was an issue adding the staffingAgency.',
        show: hasError ?? false
      }}
      >
        <Input type='text' name='name' label='Name' />
        <Input type='text' name='title' label='Title' />
        <Dropdown
          name='type'
          label='Type'
          options={lookups.types}
        />
        <Input type='text' name='email' label='E-Mail' />
        <Phone name='phone' label='Phone' />
        <Address />
        <Dropdown
          name='timezone'
          label='Timezone'
          options={lookups.timezones}
        />
      </Body>
      <Footer
        toggle={toggle}
        onAction={handleSubmit}
        action={{
          text: 'Create',
          icon: isLoading === true ? faSpinner : faPlus,
          color: 'primary',
          disabled: canSave
        }}
      />
    </>
  )
}

export default Form
